'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.findFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/findFromIndex.js
// module id = 373
// module chunks = 0